import { render } from "./Pagelabel.vue?vue&type=template&id=203775c8"
import script from "./Pagelabel.vue?vue&type=script&lang=js"
export * from "./Pagelabel.vue?vue&type=script&lang=js"

import "./Pagelabel.vue?vue&type=style&index=0&id=203775c8&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__